// extracted by mini-css-extract-plugin
export var active = "_bb-d";
export var blink = "_bb-e";
export var container = "_bb-5";
export var controls = "_bb-0";
export var controlsRight = "_bb-1";
export var fakeCursor = "_bb-c";
export var hidden = "_bb-b";
export var quillContainerSmall = "_bb-7";
export var quillEditor = "_bb-6";
export var quillEditorSmall = "_bb-8";
export var quillFormatButtons = "_bb-a";
export var quillToolbar = "_bb-9";
export var removePadding = "_bb-2";
export var state = "_bb-3";
export var stateTitle = "_bb-4";